import { UID } from '@fullstory/util/uid';

export enum AppCacheStatus {
  // The default status before any loading has happened
  Initial = 'INITIAL',
  // Fetching new data on initial load or in refresh state
  IsLoading = 'IS_LOADING',
  // Errored after fetching for data
  LoadFailed = 'LOAD_FAILED',
  // Fetching new data after being in middle state
  IsRefetching = 'IS_REFETCHING',
  // Holding onto newer data
  HasData = 'HAS_DATA',
  // Rendering new data
  Fresh = 'FRESH',
}

export enum AppCacheActionTypes {
  IsLoading = 'appCache.IsLoading',
  LoadFailed = 'appCache.LoadFailed',
  IsRefetching = 'appCache.IsRefetching',
  HasData = 'appCache.HasData',
  Fresh = 'appCache.Fresh',
  Swap = 'appCache.Swap',
  Clear = 'appCache.Clear',
}

export interface AppCacheData<T> {
  status: AppCacheStatus;
  ready: boolean;
  data?: T;
  newData?: T | null;
  safeMessage: string | null;
  currentID: UID | null;
}
